import type { HiderCard } from '../../shared/protocol';

/** Detail sheet for a hand card. Bonuses and curses Play directly; a Veto is
 *  played from the incoming-question panel, so its sheet is informational. */
export function HiderCardSheet({
  card,
  onPlay,
  onCancel,
}: {
  card: HiderCard;
  onPlay: (c: HiderCard) => void;
  onCancel: () => void;
}) {
  const playable = card.kind !== 'veto';
  return (
    <div className="sheet-backdrop" onClick={onCancel} data-testid="hider-sheet">
      <div className="sheet" onClick={(e) => e.stopPropagation()}>
        <div className="sheet__name">{card.label}</div>
        <div className="sheet__data">
          {/* v18 BOLT-082: the effect is more useful than a category was. */}
          {card.kind === 'bonus' ? 'Time bonus' : card.kind === 'veto' ? 'Power-up' : card.effect}
        </div>
        <div className="sheet__desc">{card.effect}</div>
        <div className="sheet__actions">
          <button className="btn" onClick={onCancel}>
            Cancel
          </button>
          <button
            className="btn btn--signal"
            disabled={!playable}
            data-testid="hider-play"
            onClick={() => onPlay(card)}
          >
            {card.kind === 'bonus' ? 'Bank it' : card.curse === 'portal' ? 'Place it' : card.kind === 'curse' ? 'Cast it' : 'Use it when a card comes in'}
          </button>
        </div>
      </div>
    </div>
  );
}
